import { render } from "./TextLink.vue?vue&type=template&id=4bf16faa&scoped=true"
import script from "./TextLink.vue?vue&type=script&lang=js"
export * from "./TextLink.vue?vue&type=script&lang=js"

import "./TextLink.vue?vue&type=style&index=0&id=4bf16faa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf16faa"]])

export default __exports__